import { Endpoint, Service } from "../../const";

//Directory Actions

const endpoint = Endpoint.Directory;
export const DirectoryService = {
    GetDirectory: ( token = "") => Service.Request.Get(endpoint + "/fetch", token),
}
